import { render, staticRenderFns } from "./BlockWidget.vue?vue&type=template&id=3c537ada&scoped=true&"
import script from "./BlockWidget.vue?vue&type=script&lang=js&"
export * from "./BlockWidget.vue?vue&type=script&lang=js&"
import style0 from "./BlockWidget.vue?vue&type=style&index=0&id=3c537ada&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c537ada",
  null
  
)

export default component.exports